import { render, staticRenderFns } from "./vFormEditor.vue?vue&type=template&id=147d010c&scoped=true&"
import script from "./vFormEditor.vue?vue&type=script&lang=js&"
export * from "./vFormEditor.vue?vue&type=script&lang=js&"
import style0 from "./vFormEditor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./vFormEditor.vue?vue&type=style&index=1&id=147d010c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147d010c",
  null
  
)

export default component.exports